import {
	AddressFields,
	CitizenshipAutocomplete,
	CountryAutocomplete,
	EmailField,
	NameField,
	PepFields,
	PhoneField,
} from 'web/components/user/UserInputFields';

export default function UserProfileFormFields() {
	return (
		<>
			<NameField />

			<EmailField />

			<PhoneField />

			<AddressFields />

			<CountryAutocomplete />

			<CitizenshipAutocomplete />

			<PepFields />
		</>
	);
}
